/** Entry banner for Draw Together ("Is someone drawing with you?") shown on lesson cards. */
import { useNavigate } from 'react-router-dom';
import { useT } from '../lib/i18n';
import { useActiveProfile, useApp } from '../state/store';
import { Avatar } from './characters';
import { Button } from './ui';

export function DrawTogetherBanner({ miniUnitId, from }: { miniUnitId: string; from?: string }) {
  const t = useT();
  const nav = useNavigate();
  const enabled = useApp((s) => s.config.enableDrawTogether);
  const host = useActiveProfile();
  if (!enabled || !host) return null;
  return (
    <div className="dt-banner card row" data-testid="draw-together-banner">
      <div className="dt-banner-avatars">
        <Avatar avatar={host.avatar} character={host.character} size={36} />
        <Avatar avatar="bear" size={36} />
      </div>
      <div className="grow col dt-banner-text">
        <b>{t('dt.question')}</b>
        <span className="muted">{t('dt.bannerBody')}</span>
      </div>
      <Button small variant="secondary" icon="users" onClick={() => nav(`/draw-together?mu=${encodeURIComponent(miniUnitId)}${from ? `&from=${encodeURIComponent(from)}` : ''}`)}>
        {t('dt.bannerCta')}
      </Button>
    </div>
  );
}
